@if (fontIcon()) {
    <i
        class="ai-icon {{ fontIcon() }} {{ styleClass() ?? '' }}"
        [ngStyle]="style()"
    ></i>
} @else {
    <i
        class="ai-icon"
        [ngStyle]="{
            'background-image': 'url(' + imageIcon() + ')',
            'background-size': 'contain',
            'background-repeat': 'no-repeat',
            'background-position': 'center'
        }"
    ></i>
}
